/**
 * <LiveReportsListSkeleton> — la forme de l'onglet « Rapports » pendant son premier chargement.
 *
 * Trois cartes de rapport posées comme `<InfiniteList>` pose les vraies (mêmes retraits, même
 * écart) : `<LiveReportCardSkeleton>`, à la largeur et aux deux lignes de commentaire de
 * `<LiveReportCard>`.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { LiveReportCardSkeleton } from "../../organisms/LiveReportCard/LiveReportCardSkeleton"

export function LiveReportsListSkeleton() {
    return (
        <View style={styles.list}>
            {[0, 1, 2].map((index) => (
                <LiveReportCardSkeleton key={index} commentLines={2} />
            ))}
        </View>
    )
}

const styles = StyleSheet.create((theme) => ({
    /** Les retraits et l'écart de `<InfiniteList>`. */
    list: {
        paddingHorizontal: theme.spacing["3"],
        paddingTop: theme.spacing["3"],
        gap: theme.spacing["4"],
    },
}))
